export * from './team-color.component';
